/**
 * @Author: v_jppjpeng
 * @Date: 2023-2-9 09:48:13
 * @Explain: 首页
 */

export default {
  // Campaigns 模块
  'HOME.CAMPAIGNS.TITLE': 'Latest campaign performance',
  'HOME.CAMPAIGNS.GO': 'Campaign reports',
  'HOME.CAMPAIGNS.LABEL.NAME': 'Campaign name',
  'HOME.CAMPAIGNS.LABEL.TIME': 'Delivery date',
  'HOME.CAMPAIGNS.LABEL.CIRCLE': 'Cycle',
  'HOME.CAMPAIGNS.NUM.1': 'Sent',
  'HOME.CAMPAIGNS.NUM.DESC.1': 'Number of emails sent',
  'HOME.CAMPAIGNS.NUM.2': 'Delivered',
  'HOME.CAMPAIGNS.NUM.DESC.2':
    "Number of emails successfully delivered to users' email server",
  'HOME.CAMPAIGNS.PERCENT.TITLE.2': 'Delivery Rate',
  'HOME.CAMPAIGNS.PERCENT.DESC.2': 'Delivery Rate = Delivered / Sent',
  'HOME.CAMPAIGNS.NUM.3': 'Opened',
  'HOME.CAMPAIGNS.NUM.DESC.3': 'Number of emails opened',
  'HOME.CAMPAIGNS.PERCENT.TITLE.3': 'Open Rate',
  'HOME.CAMPAIGNS.PERCENT.DESC.3': 'Open Rate = Opened / Delivered',
  'HOME.CAMPAIGNS.NUM.4': 'Unsubscribes',
  'HOME.CAMPAIGNS.NUM.DESC.4': 'Number of unsubscribes from this campaign',
  'HOME.CAMPAIGNS.PERCENT.TITLE.4': 'Unsubscribe Rate',
  'HOME.CAMPAIGNS.PERCENT.DESC.4':
    'Unsubscribe Rate = Unsubscribes / Delivered',
  'HOME.CAMPAIGNS.NUM.5': 'Registered users',
  'HOME.CAMPAIGNS.NUM.DESC.5':
    'Number of registrations out of total number of delivered emails',
  'HOME.CAMPAIGNS.PERCENT.TITLE.5': 'Registration Rate',
  'HOME.CAMPAIGNS.PERCENT.DESC.5':
    'Registration Rate = Registered users  / Delivered',
  'HOME.CAMPAIGNS.NUM.6': 'Active users',
  'HOME.CAMPAIGNS.NUM.DESC.6':
    'Number of registrations out of total number of delivered emails',
  'HOME.CAMPAIGNS.PERCENT.TITLE.6': 'Activation Rate',
  'HOME.CAMPAIGNS.PERCENT.DESC.6': 'Activation Rate = Active users / Delivered',
  'HOME.CAMPAIGNS.NUM.7': 'Paying users',
  'HOME.CAMPAIGNS.NUM.DESC.7':
    'Number of paying users out of total number of delivered emails',
  'HOME.CAMPAIGNS.PERCENT.TITLE.7': 'Paying Users Rate',
  'HOME.CAMPAIGNS.PERCENT.DESC.7':
    'Paying Users Rate = Paying users / Delivered',
  'HOME.CAMPAIGNS.NUM.8': 'Clicked',
  'HOME.CAMPAIGNS.NUM.DESC.8': 'Number of emails where the link was clicked',
  'HOME.CAMPAIGNS.PERCENT.TITLE.8': 'Click rate',
  'HOME.CAMPAIGNS.PERCENT.DESC.8': 'Click rate = Clicked / Delivered',
  'HOME.CAMPAIGNS.NUM.10': 'Recipients',
  'HOME.CAMPAIGNS.NUM.DESC.10':
    'The total number of recipients based on campaign settings',

  // Subscribers 模块
  'HOME.SUBSCRIBERS.TITLE': 'Total subscribers',
  'HOME.SUBSCRIBERS.DESC.ADD':
    "Gained <b class='color-primary'>{num}</b> subscribers in the past week",
  'HOME.SUBSCRIBERS.DESC.REDUCE':
    "Lost <b class='color-primary'>{num}</b> subscribers in the past week",
  'HOME.SUBSCRIBERS.DESC.NO.CHANGE': '<span>No changes in the past week</span>',
  'HOME.SUBSCRIBERS.GO': 'Details',
  // Regional and language distribution of subscribers 模块
  'HOME.SUBSCRIBERSANDLANGUAGE.TITLE': 'Subscriber distribution',
  'HOME.SUBSCRIBERSANDLANGUAGE.BY.REGION': 'By region',
  'HOME.SUBSCRIBERSANDLANGUAGE.BY.LANGUAGE': 'By language',
  'HOME.SUBSCRIBERSANDLANGUAGE.BY.PREFERENCE': 'By preference',
  'HOME.SUBSCRIBERSANDLANGUAGE.PREFERENCE': 'Subscriber preferences',
  // 偏好饼图查询 未设置偏好
  'HOME.SUBSCRIBERS.PREFERENCE.NOTSET': 'No preferences',

  'HOME.SUBSCRIBERSANDLANGUAGE.OTHERS': 'Others',
  'HOME.SUBSCRIBERSANDLANGUAGE.OTHERS.HEADER.NAME': 'Region',
  'HOME.SUBSCRIBERSANDLANGUAGE.OTHERS.HEADER.VALUE': 'Subscriber',
  'HOME.SUBSCRIBERSANDLANGUAGE.OTHERS.HEADER.PERCENT': 'Overall percentage',
  // ToDoList 模块
  'HOME.TODOLIST.TITLE': 'To-dos',
  'HOME.TODOLIST.QUICKSETUP': 'Quick setup',
  'HOME.TODOLIST.QUICKSETUP.1': 'Domain authentication',
  'HOME.TODOLIST.QUICKSETUP.1.DESC':
    'Verify the identity of your sending domain',
  'HOME.TODOLIST.QUICKSETUP.2': 'Common sender address',
  'HOME.TODOLIST.QUICKSETUP.2.DESC':
    'Set up frequently used email addresses for quick selection when creating campaigns',
  'HOME.TODOLIST.QUICKSETUP.3': 'Common sender name',
  'HOME.TODOLIST.QUICKSETUP.3.DESC':
    'Choose a sender name that subscribers will instantly recognize, for example your game name',
  'HOME.TODOLIST.QUICKSETUP.4': 'List of campaign testers',
  'HOME.TODOLIST.QUICKSETUP.4.DESC':
    'Set up a list of testers to verify the campaign before it is launched',
  'HOME.TODOLIST.QUICKSETUP.11': 'Account settings',
  'HOME.TODOLIST.QUICKSETUP.11.DESC': 'Set up 2FA and timezone preference',
  'HOME.TODOLIST.APPROVAL': 'Pending approval',
  'HOME.TODOLIST.OVER': 'You have completed all to-dos',
  'HOME.TODOLIST.APPROVAL.DESC': 'Details',
  'HOME.FEEDBACK.BTN': 'Feedback',
  'HOME.FEEDBACK.TITLE': 'Help us improve SmartLink 😀 ',
  'HOME.FEEDBACK.TITLE.LABEL': 'Title',
  'HOME.FEEDBACK.TITLE.REQUIRED.MSG': 'Please enter title',
  'HOME.FEEDBACK.DESCRIPTION.LABEL': 'Description',
  'HOME.FEEDBACK.SCREENSHOTS.LABEL': 'Screenshot(s)',
  'HOME.FEEDBACK.SCREENSHOTS.TIPS':
    'We support JPG, PNG, and GIF formats. You can upload up to 3 images, with each file no larger than 5MB',
  'HOME.FEEDBACK.SCREENSHOTS.SIZE.LIMIT.MSG':
    "This image is too large. Please upload one that's under {sizeLimit}.",
  'HOME.FEEDBACK.SCREENSHOTS.MAX.FILE.LIMIT.MSG':
    'Reach the maximum number of image',
  'HOME.FEEDBACK.SCREENSHOTS.UPLOAD.FAIL.MSG': 'Time out. Please upload again.',
  'HOME.FEEDBACK.TITLE.PLACEHOLDER':
    'Summarize your question or suggestion in one sentence',
  'HOME.FEEDBACK.DESCRIPTION.PLACEHOLDER':
    'Describe in detail the issue you encountered, your suggestions, or areas where you think we can improve. If this is a bug report, please provide the reproduction steps as clearly as possible.',
  'HOME.FEEDBACK.CATEGORY.LABEL': 'Category',
  'HOME.FEEDBACK.CATEGORY.OPTION.BUG.REPORT': 'Bug Report',
  'HOME.FEEDBACK.CATEGORY.OPTION.FEATURE.REQUEST': 'Feature Request',
  'HOME.FEEDBACK.CATEGORY.OPTION.USABILITY.ISSUE': 'Usability Issue',
  'HOME.FEEDBACK.CATEGORY.OPTION.VISUAL.PROBLEM': 'Visual Problem',
  'HOME.FEEDBACK.CATEGORY.OPTION.QUESTION.HELP': 'Question/Help',
  'HOME.FEEDBACK.CATEGORY.OPTION.OTHERS': 'Other',
  'HOME.FEEDBACK.SUBMIT.SUCCESS':
    'Submitted successfully, thanks for your feedback.',
  'HOME.FEEDBACK.SUBMIT.TIPS.MSG': 'Please fill in the required fields',
  'HOME.ANNOUNCEMENT.SYSTEM.TITLE': 'System Announcement',
  'HOME.ANNOUNCEMENT.REMINDER': 'Do not remind me again',
  'HOME.ANNOUNCEMENT.TEAM': 'SmartLink Team',
  'HOME.ANNOUNCEMENT.VERSION.UPDATE': 'New features',

  // 首页重构
  'HOME.SEND.EMAIL': 'Send emails',
  'HOME.QUICK.ACTION': 'Quick action',
  'HOME.QUICK.ACTION.ADD.CONTACTS.CSV': 'Import contacts by csv',
  'HOME.QUICK.ACTION.ADD.TEMPLATE.MARKETING':
    'Create a marketing email template',
  'HOME.QUICK.ACTION.ADD.SEGMENT': 'Create a segment',
  'HOME.COMPAIGNS.TAB.EMAIL': 'Email',
  'HOME.COMPAIGNS.TAB.WHATSAPP': 'WhatsApp',
  'HOME.COMPAIGNS.MORE': 'more',
  'HOME.COMPAIGNS.TITLE': 'Recent campaigns performance',
  'HOME.COMPAIGNS.NAME': 'Name',
  'HOME.COMPAIGNS.CATEGORY': 'Category',
  'HOME.COMPAIGNS.STATUS': 'Status',
  'HOME.COMPAIGNS.RECIPIENTS': 'Recipients',
  'HOME.COMPAIGNS.SENT': 'Sent',
  'HOME.COMPAIGNS.DELIVERY.RATE': 'Delivery rate',
  'HOME.COMPAIGNS.OPEN.RATE': 'Open rate',
  'HOME.COMPAIGNS.CTOR': 'CTOR',
  'HOME.COMPAIGNS.UNSUBSCRIBE.RATE': 'Unsubscribe rate',
  'HOME.COMPAIGNS.READ.RATE': 'Read rate',
  'HOME.COMPAIGNS.REPLIED.RATE': 'Replied rate',
  'HOME.COMPAIGNS.EMPTT.TITLE': '	No campaigns yet',
  'HOME.COMPAIGNS.EMPTT.DESC':
    'Create your first campaign to engage players and track how they respond here.',
  'HOME.COMPAIGNS.EMPTT.CREATE.EMAIL': 'Create the first email campaign',
  'HOME.COMPAIGNS.EMPTT.CREATE.WHATSAPP': 'Create the first WhatsApp campaign',
  'HOME.COMPAIGNS.NO.OERMISSION.TITLE': '	Welcome to WhatsApp!',
  'HOME.COMPAIGNS.NO.OERMISSION.DESC':
    'Before you start, please contact the SmartLink team to help configure your sender number.',
  'HOME.COMPAIGNS.NO.OERMISSION.LINK':
    'You can also check the <a class="color-primary font-poppins" href="{url}" target="_blank" style="text-decoration: none;">WhatsApp Guide</a> first.',
  'HOME.CONTACTS.LEAD.TITLE': 'No contacts yet',
  'HOME.CONTACTS.LEAD.DESC':
    'Import your contacts to start tracking your player growth.',
  'HOME.CONTACTS.LEAD.CREATE': 'Import contacts',
  'HOME.CONTACTS.TREND.TITLE': 'Contacts trend',
  'HOME.CONTACTS.ALL.NUMBER': 'Total contacts',
  'HOME.CONTACTS.SUBSCRIBERS': 'Total subscribers',
  'HOME.CONTACTS.CONTACTS.BREAKDOWN.TITLE': 'Contacts breakdown',
  'HOME.CONTACTS.ALL': 'All contacts',
  'HOME.CONTACTS.SUB': 'All subscribers',
};
